import ReceiptList from './receipt-list'
export default ReceiptList
